import "./style.scss";
import MediaObject from "./MediaObject";
import React from "react";
import { withRouter } from "react-router-dom";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Button, ListGroup, ListGroupItem } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";

@injectIntl
@inject("membersStore", "rootStore")
@observer
class ItemsPanel extends React.Component {
  nextPath(path) {
    this.props.history.push(path);
  }

  render() {
    let { membersStore, e, items } = this.props;
    return (
      <ListGroup
        id={membersStore.members[e] ? "users-list" : "send-invitations"}
      >
        {membersStore.members[e] ? (
          membersStore.members[e].map((m, idx) => (
            <ListGroupItem key={idx}>
              <MediaObject member={m} items={items} />
            </ListGroupItem>
          ))
        ) : (
          <div className="center">
            <div>
              <Button
                bsStyle="primary"
                onClick={() => {
                  this.nextPath("/memberships/affiliation");
                }}
              >
                {this.props.intl.formatMessage({ id: "send_invitation" })}
              </Button>
            </div>
          </div>
        )}
      </ListGroup>
    );
  }
}
export default withRouter(ItemsPanel);
